// extracted by mini-css-extract-plugin
export default {"icon":"ButtonEye_icon__LXhWT"};